import React, { Children } from 'react';
import { Layout } from '../components/Layout';
import { Container } from '../components/ui/Container';
export function PrivacyPage() {
  return <Layout data-id="element-345">
      <div className="bg-slate-50 py-12 border-b border-slate-200" data-id="element-346">
        <Container data-id="element-347">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-348">
            Privacy Policy
          </h1>
          <p className="text-slate-600" data-id="element-349">
            Last Updated: {new Date().toLocaleDateString()}
          </p>
        </Container>
      </div>

      <Container className="py-16 max-w-4xl" data-id="element-350">
        <div className="prose prose-slate max-w-none space-y-8" data-id="element-351">
          <section data-id="element-352">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-353">
              1. Introduction
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-354">
              BRIXEN CREDIT LLC ("we," "our," or "us") is committed to
              protecting your privacy. This Privacy Policy explains how we
              collect, use, disclose, and safeguard your information when you
              visit our website brixencredit.com and use our services.
            </p>
            <div className="bg-blue-50 border-l-4 border-blue-600 p-4 my-4" data-id="element-355">
              <p className="text-sm text-blue-900 font-medium" data-id="element-356">
                Important: Brixen Credit provides educational and consulting
                services only. We are not a credit bureau, lender, or law firm.
              </p>
            </div>
          </section>

          <section data-id="element-357">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-358">
              2. SMS / Text Messaging and Opt-In Data
            </h2>
            <div className="bg-green-50 border-l-4 border-green-600 p-5 my-4" data-id="element-359">
              <p className="text-sm text-green-900 font-semibold mb-2" data-id="element-360">
                Your SMS opt-in data is never shared.
              </p>
              <p className="text-sm text-green-800 leading-relaxed mb-2" data-id="element-361">
                BRIXEN CREDIT LLC does NOT share, sell, or rent your personal
                information, phone numbers, or SMS opt-in data with any third
                parties for marketing purposes.
              </p>
              <p className="text-sm text-green-800 leading-relaxed" data-id="element-362">
                SMS opt-in consent is not shared with third parties or
                affiliates under any circumstances.
              </p>
            </div>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-363">
              If you choose to provide your mobile number and opt in to receive
              text messages from us, we use it solely to communicate with you
              about your inquiry or services you have requested. Message
              frequency varies. Message and data rates may apply. You can reply
              STOP at any time to unsubscribe, or HELP for assistance. Opting
              out of SMS will not affect your ability to use our other services.
            </p>
          </section>

          <section data-id="element-364">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-365">
              3. Information We Collect
            </h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-366">
              2.1 Personal Information You Provide
            </h3>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-367">
              We collect information that you voluntarily provide to us when
              you:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-368">
              <li data-id="element-369">Request a consultation through our contact forms</li>
              <li data-id="element-370">Contact us by phone or email regarding our services</li>
              <li data-id="element-371">Communicate with us via email, phone, or other channels</li>
              <li data-id="element-372">Create an account or use our services</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-373">
              This information may include:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-374">
              <li data-id="element-375">Full name</li>
              <li data-id="element-376">Email address</li>
              <li data-id="element-377">Phone number</li>
              <li data-id="element-378">State of residence</li>
              <li data-id="element-379">Financial goals and consultation preferences</li>
              <li data-id="element-380">
                Any other information you choose to provide in forms or
                communications
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-381">
              2.2 Automatically Collected Information
            </h3>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-382">
              When you visit our website, we may automatically collect certain
              information about your device and usage patterns, including:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-383">
              <li data-id="element-384">IP address and browser type</li>
              <li data-id="element-385">Operating system and device information</li>
              <li data-id="element-386">Pages visited, time spent on pages, and navigation paths</li>
              <li data-id="element-387">Referring website or source</li>
              <li data-id="element-388">Date and time of access</li>
            </ul>
          </section>

          <section data-id="element-389">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-390">
              3. How We Use Your Information
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-391">
              We use the information we collect for the following purposes:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-392">
              <li data-id="element-393">
                <strong data-id="element-394">Service Delivery:</strong> To provide educational
                consulting services, respond to consultation requests, and
                communicate about your financial education goals
              </li>
              <li data-id="element-395">
                <strong data-id="element-396">Communication:</strong> To send you information about
                our services, educational content, updates, and respond to your
                inquiries
              </li>
              <li data-id="element-397">
                <strong data-id="element-398">Improvement:</strong> To analyze website usage and
                improve our services, content, and user experience
              </li>
              <li data-id="element-399">
                <strong data-id="element-400">Legal Compliance:</strong> To comply with applicable
                laws, regulations, and legal processes
              </li>
              <li data-id="element-401">
                <strong data-id="element-402">Security:</strong> To protect against fraud,
                unauthorized access, and other security risks
              </li>
            </ul>
          </section>

          <section data-id="element-403">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-404">
              4. Information Sharing and Disclosure
            </h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-405">
              4.1 We Do Not Sell Your Data
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-406">
              BRIXEN CREDIT LLC does not sell, rent, or trade your personal
              information to third parties for marketing purposes.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-407">
              4.2 Limited Sharing
            </h3>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-408">
              We may share your information only in the following circumstances:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-409">
              <li data-id="element-410">
                <strong data-id="element-411">Service Providers:</strong> With trusted third-party
                service providers who assist us in operating our website,
                conducting our business, or servicing you (e.g., email service
                providers, payment processors, hosting providers). These parties
                are contractually obligated to keep your information
                confidential.
              </li>
              <li data-id="element-412">
                <strong data-id="element-413">Legal Requirements:</strong> When required by law, court
                order, or government regulation, or to protect our rights,
                property, or safety.
              </li>
              <li data-id="element-414">
                <strong data-id="element-415">Business Transfers:</strong> In connection with a
                merger, acquisition, or sale of assets, your information may be
                transferred to the acquiring entity.
              </li>
              <li data-id="element-416">
                <strong data-id="element-417">With Your Consent:</strong> When you explicitly
                authorize us to share your information for a specific purpose.
              </li>
            </ul>
          </section>

          <section data-id="element-418">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-419">
              5. Cookies and Tracking Technologies
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-420">
              We use cookies and similar tracking technologies to enhance your
              experience on our website. Cookies are small data files stored on
              your device that help us:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-421">
              <li data-id="element-422">Remember your preferences and settings</li>
              <li data-id="element-423">Understand how you use our website</li>
              <li data-id="element-424">Improve website functionality and performance</li>
              <li data-id="element-425">Provide relevant content and advertising</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-426">
              You can control cookies through your browser settings. However,
              disabling cookies may limit your ability to use certain features
              of our website.
            </p>
          </section>

          <section data-id="element-427">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-428">
              6. Data Security
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-429">
              We implement industry-standard security measures to protect your
              personal information from unauthorized access, disclosure,
              alteration, or destruction. These measures include:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-430">
              <li data-id="element-431">
                Secure Socket Layer (SSL) encryption for data transmission
              </li>
              <li data-id="element-432">Secure servers protected by firewalls</li>
              <li data-id="element-433">
                Restricted access to personal information on a need-to-know
                basis
              </li>
              <li data-id="element-434">Regular security audits and updates</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-435">
              While we strive to protect your information, no method of
              transmission over the internet or electronic storage is 100%
              secure. We cannot guarantee absolute security.
            </p>
          </section>

          <section data-id="element-436">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-437">
              7. Data Retention
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-438">
              We retain your personal information only for as long as necessary
              to fulfill the purposes outlined in this Privacy Policy, unless a
              longer retention period is required or permitted by law. When
              information is no longer needed, we will securely delete or
              anonymize it.
            </p>
          </section>

          <section data-id="element-439">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-440">
              8. Your Rights and Choices
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-441">
              Depending on your location, you may have the following rights
              regarding your personal information:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-442">
              <li data-id="element-443">
                <strong data-id="element-444">Access:</strong> Request access to the personal
                information we hold about you
              </li>
              <li data-id="element-445">
                <strong data-id="element-446">Correction:</strong> Request correction of inaccurate or
                incomplete information
              </li>
              <li data-id="element-447">
                <strong data-id="element-448">Deletion:</strong> Request deletion of your personal
                information, subject to legal and contractual obligations
              </li>
              <li data-id="element-449">
                <strong data-id="element-450">Opt-Out:</strong> Unsubscribe from marketing
                communications at any time
              </li>
              <li data-id="element-451">
                <strong data-id="element-452">Data Portability:</strong> Request a copy of your
                information in a structured, commonly used format
              </li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-453">
              To exercise any of these rights, please contact us at
              info@brixencredit.com. We will respond to your request within a
              reasonable timeframe.
            </p>
          </section>

          <section data-id="element-454">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-455">
              9. Third-Party Links
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-456">
              Our website may contain links to third-party websites or services.
              We are not responsible for the privacy practices or content of
              these external sites. We encourage you to review the privacy
              policies of any third-party sites you visit.
            </p>
          </section>

          <section data-id="element-457">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-458">
              10. Children's Privacy
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-459">
              Our services are not directed to individuals under the age of 18.
              We do not knowingly collect personal information from children. If
              we become aware that we have collected information from a child
              without parental consent, we will take steps to delete that
              information promptly.
            </p>
          </section>

          <section data-id="element-460">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-461">
              11. Changes to This Privacy Policy
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-462">
              We may update this Privacy Policy from time to time to reflect
              changes in our practices or legal requirements. We will notify you
              of any material changes by posting the updated policy on our
              website with a new "Last Updated" date. Your continued use of our
              services after such changes constitutes acceptance of the updated
              policy.
            </p>
          </section>

          <section data-id="element-463">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-464">
              12. Contact Us
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-465">
              If you have questions, concerns, or requests regarding this
              Privacy Policy or our data practices, please contact us:
            </p>
            <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 mt-4" data-id="element-466">
              <p className="font-semibold text-slate-900 mb-2" data-id="element-467">
                BRIXEN CREDIT LLC
              </p>
              <p className="text-slate-700" data-id="element-468">390 NE 191ST ST STE 8123</p>
              <p className="text-slate-700" data-id="element-469">Miami, FL 33179</p>
              <p className="text-slate-700 mt-3" data-id="element-470">
                Email: info@brixencredit.com
              </p>
              <p className="text-slate-700" data-id="element-471">Phone: 786-376-3985</p>
            </div>
          </section>

          <div className="bg-amber-50 border-l-4 border-amber-600 p-6 mt-8" data-id="element-472">
            <p className="text-sm text-amber-900 font-medium mb-2" data-id="element-473">
              Disclaimer
            </p>
            <p className="text-sm text-amber-800 leading-relaxed" data-id="element-474">
              BRIXEN CREDIT LLC provides educational and consulting services
              only. We do not guarantee specific outcomes, credit score
              increases, approvals, or financial results. We are not a credit
              bureau, lender, or law firm. Results vary by individual financial
              profile.
            </p>
          </div>
        </div>
      </Container>
    </Layout>;
}